import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FeaturesSectionSchema } from '../types/FeaturesSectionSchema';

const initialState: FeaturesSectionSchema = {
    
};

export const FeaturesSectionSlice = createSlice({
    name: 'FeaturesSection',
    initialState,
    reducers: {
        template: (state, action: PayloadAction<string>) => {
           
        },
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(, (state) => {
    //             state.error = undefined;
    //             state.isLoading = true;
    //         })
    //         .addCase(, (state) => {
    //             state.isLoading = false;
    //         })
    //         .addCase(, (state, action) => {
    //             state.isLoading = false;
    //             state.error = action.payload;
    //         });
    // },
});

export const { actions: FeaturesSectionActions } = FeaturesSectionSlice;
export const { reducer: FeaturesSectionReducer } = FeaturesSectionSlice;